import { camelCaseToTitle } from "../../../../../../../helpers/StringHelper";

export const mapData = ({
  data,
  setDaily,
  setWeekly,
  setMonthly,
}) => {
  const dailyData = [];
  const weeklyData = [];
  const monthlyData = [];

  Object.keys(data.pastMonth).forEach((key) => {
    for (const [type, value] of Object.entries(data.pastMonth[key])) {
      dailyData.push({ type, value, series: camelCaseToTitle(key) });
    }
  });

  Object.keys(data.past3Months).forEach((key) => {
    for (const [type, value] of Object.entries(data.past3Months[key])) {
      weeklyData.push({ type, value, series: camelCaseToTitle(key) });
    }
  });

  Object.keys(data.past12Months).forEach((key) => {
    for (const [type, value] of Object.entries(data.past12Months[key])) {
      monthlyData.push({ type, value, series: camelCaseToTitle(key) });
    }
  });

  setDaily(dailyData);
  setWeekly(weeklyData);
  setMonthly(monthlyData);
}

export const getRange = (max) => {
  let range = [];
  if (max === 0) {
    return [1, 2, 3, 4, 5];
  }

  const push = (j, max, f) => {
    for (let i = j; i <= max; i += f) {
      range.push(i);
    }
  }

  if (max <= 6) {
    push(1, max, 1);
  } else {
    let go = true;
    let i = 2;

    while (go) {
      if (max % i === 0) {
        go = false;
      } else {
        i += 1;
      }
    }

    if (i === max) {
      const tenth = Math.ceil(i / 10) * 10;
      if (tenth === 10) {
        return [2, 4, 6, 8, 10];
      } else {
        let i = 2;
        let go = true;
        while (go) {
          if (tenth / i < 5) {
            go = false;
          } else {
            i += 1;
          }
        }
        push(0, tenth, i);
        const m = Math.max(...range);
        if (!range.includes(tenth)) {
          if (m < tenth && m < max) {
            range.push(m + i);
          }
        }
        if (m - i > max) {
          range = range.filter((b) => b !== m);
        }
      }
    } else {
      let i = 2;
      let go = true;
      while (go) {
        if (max % i === 0) {
          go = false;
        } else {
          i += 1;
        }
      }
      go = true;
      while (go) {
        if (max / i < 5) {
          go = false;
        } else {
          i += i;
        }
      }
      push(0, max, i);
      if (!range.includes(max)) {
        const m = Math.max(...range);
        range.push(m + i);
      }
    }
  }

  return range.filter((i) => i !== 0);
}
